/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Countdown Timer to a Date (Days, Hours, Minutes) — Toolverse`)
};

const es_cd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta Atrás para una Fecha (Días, Horas, Minutos) — Toolverse`)
};

const de_cd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Countdown-Timer zu einem Datum (Tage, Stunden, Minuten) — Toolverse`)
};

const nl_cd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aftelklok naar een Datum (Dagen, Uren, Minuten) — Toolverse`)
};

const fr_cd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compte à Rebours vers une Date (Jours, Heures, Minutes) — Toolverse`)
};

const it_cd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timer conto alla rovescia verso una data (giorni, ore, minuti) — Toolverse`)
};

const pt_br2_cd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronômetro de Contagem Regressiva (Dias, Horas, Minutos) — Toolverse`)
};

const pt_cd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temporizador de Contagem Decrescente até uma Data (Dias, Horas, Minutos) — Toolverse`)
};

const ja_cd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日付までのカウントダウンタイマー(日・時・分) — Toolverse`)
};

const zh_cd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日期倒计时器（天、时、分）— Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cd_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cd_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cd_meta_title", locale)
	if (locale === "en") return en_cd_meta_title(inputs)
	if (locale === "es") return es_cd_meta_title(inputs)
	if (locale === "de") return de_cd_meta_title(inputs)
	if (locale === "nl") return nl_cd_meta_title(inputs)
	if (locale === "fr") return fr_cd_meta_title(inputs)
	if (locale === "it") return it_cd_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_cd_meta_title(inputs)
	if (locale === "pt") return pt_cd_meta_title(inputs)
	if (locale === "ja") return ja_cd_meta_title(inputs)
	return zh_cd_meta_title(inputs)
};